import React, { FunctionComponent } from 'react';
import Image from 'material-ui-image';
import carImageStyles from './carImageStyles';
import carUnavailable from '../../../../../common/assets/images/carUnavailable.png';

export interface ICarImageProps {
  imageSrc: string;
}

const CarImage: FunctionComponent<ICarImageProps> = ({ imageSrc }) => {
  const styles = carImageStyles();
  const commonInlineStyles = {
    position: 'relative',
    display: 'block',
    textAlign: 'center',
    height: 'auto',
    objectFit: 'initial',
    minHeight: 160,
  };
  const iconInlineStyles = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'block',
    textAlign: 'center',
    height: 'auto',
    objectFit: 'initial',
  };

  return (
    <Image
      src={imageSrc || 'error'}
      alt="car"
      animationDuration={2.05}
      data-test="summary:vehicle:image"
      color="transparent"
      imageStyle={commonInlineStyles}
      iconContainerStyle={iconInlineStyles}
      style={{ padding: 0, display: 'flex', flexDirection: 'column' }}
      className={styles.image}
      errorIcon={
        <img src={carUnavailable} className={styles.image} data-test={'image:model:unavailable'} alt={'car'} />
      }
    />
  );
};

export default CarImage;
